<!--
 * @Description: 医师出诊信息
 * @Author: huangshiwen
 * @Date: 2022-06-28 13:10:50
-->
<template>
  <div class="windowWrap" ref="editorDOM">
    <div v-if="!SCREEN.mobile" class="m-main">
      <div class="title1">医师出诊信息</div>
      <div class="txt1">今日：{{ date }}</div>
      <div class="box">
        <table>
          <tr>
            <th style="width:176px;padding:0;background: #d8e6f0;">
              <div class="out">
                <div class="line"></div>
                <b
                  ><img
                    src="../images/chart_date_head_icon.svg"
                    alt=""
                    class="src"
                  />
                  科室</b
                >
                <em
                  ><img
                    src="../images/chart_keshi_head_icon.svg"
                    alt=""
                    class="src"
                  />日期</em
                >
              </div>
            </th>
            <th
              style="color:#FFF"
              v-for="(item, index) in dateWeekList"
              :key="index"
            >
              <div class="title">{{ item.date }}</div>
              <div class="date">{{ item.week }}</div>
            </th>
          </tr>
          <tr v-for="(item, index) in doctorDeptPC" :key="index">
            <td
              v-if="item.maxPersonNum > 0"
              class="t1"
              :rowspan="item.maxPersonNum"
            >
              {{ item.deptName }}
            </td>
            <td
              class="columnPerson"
              v-for="(item2, index2) in item.row"
              :key="index2"
              @click="goToWebsiteBook(item.hisDeptId, item2.doctCode, index2)"
            >
              {{ item2.doctName }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-else class="mobile">
      <div class="title">
        <div class="top">
          <div class="left">医师出诊信息</div>
          <div class="right" @click="showMask()">
            <div
              class="dot
        "
            ></div>
            <div
              class="dot
        "
            ></div>
            <div
              class="dot
        "
            ></div>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <div class="allDepBox">
        <div
          :id="'dept'+index"
          class="itemDepBox"
          v-for="(item, index) in doctorDeptPhone"
          :key="index"
        >
          <div class="depName">{{ item.deptName }}</div>
          <div class="scroll">
            <div class="content">
              <div style="display:flex;width:auto">
                <div
                  class="dateWeek"
                  v-for="(item, index) in dateWeekList"
                  :key="index"
                >
                  <div class="date">{{ item.date }}</div>
                  <div class="week">{{ item.week }}</div>
                </div>
              </div>
              <div class="personName">
                <div
                  class="rowPerson"
                  v-for="(item2, index2) in item.list"
                  :key="index2"
                >
                  <div
                    class="columnPerson"
                    v-for="(item3, index3) in item2.row"
                    :key="index3"
                    @click="
                      goToWebsiteBook(item.hisDeptId, item3.doctCode, index3)
                    "
                  >
                    {{ item3.doctName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showMaskFlag" class="mask"></div>
    <div v-if="showMaskFlag" class="deptAlert">
      <div class="title">门诊筛选</div>
      <div class="deptAlertName">
        <a
          class="itemdeptName"
          v-for="(item, index) in doctorDeptPhone"
          :key="index"
          @click="hiddenMask(index)"
        >
          {{ item.deptName }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hosiptal-table-001",
  data() {
    return {
        hospitalCode: "H05",
        date: "",
        sum: 0,
        dateWeekList: [],
        doctorDeptPhone: [],
        showMaskFlag: false,
        doctorDeptPC: [],
        deptNameList: [
          { dept: "呼吸科门诊" },
          { dept: "康复医学科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" },
          { dept: "呼吸科门诊" }
        ],
        hisDeptId: "",
        hisDoctorId: "",
        dutyDate: "",
        url: ""
      }
  },
  created() {
    this.getCurrentDate();
  },
  mounted() {
    this.getDutyDoctorvisit();
    
    this.url = window.location.href;
  },
  methods: {
    getCurrentDate() {
      let myDate = new Date();
      var year = myDate.getFullYear(); //获取年
      var month = myDate.getMonth() + 1; //获取月，默认从0开始，所以要加一
      var date = myDate.getDate(); //获取日 var rslt = {};
      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      this.date = year + "." + month + "." + date;
    },
    getDutyDoctorvisit() {
      this.$API
        .getDutyDoctorvisit({
          hospitalCode: this.hospitalCode
        })
        .then(res => {
          this.$set(this, "dateWeekList", res.data.dateWeekList);
          this.$set(this, "doctorDeptPhone", res.data.doctorDeptPhone);
          this.getDataPC();
        });
    },

    getDataPC() {
      //计算行数PC端
      var temp = this.doctorDeptPhone;
      for (var i = 0; i < this.doctorDeptPhone.length; i++) {
        temp[i].list[0].deptName = this.doctorDeptPhone[i].deptName;
        temp[i].list[0].maxPersonNum = this.doctorDeptPhone[i].maxPersonNum;
        temp[i].list[0].hisDeptId = this.doctorDeptPhone[i].hisDeptId;

        for (var j = 0; j < this.doctorDeptPhone[i].list.length; j++) {
          if (j > 1) {
            temp[i].list[j].maxPersonNum = 0;
            temp[i].list[j].hisDeptId = this.doctorDeptPhone[i].hisDeptId;
          }
          this.doctorDeptPC = this.doctorDeptPC.concat(temp[i].list[j]);
        }
      }
      console.log("this.doctorDeptPC", this.doctorDeptPC);
    },
    showMask() {
      this.showMaskFlag = true;
    },
    hiddenMask(index) {
      document.getElementById('dept'+index).scrollIntoView()
      this.showMaskFlag = false;
    },
    goToWebsiteBook(arg1, arg2, arg3) {
      if (arg2 != "") {
        this.hisDeptId = arg1;
        this.hisDoctorId = arg2;
        this.dutyDate = this.dateWeekList[arg3].exactDate;
        this.$router.push({
          path:"/medicalCenter/websiteBook",
          query:{
            hisDeptId:this.hisDeptId,
            hisDoctorId:this.hisDoctorId,
            dutyDate:this.dutyDate
          }
        })
      }
    }
  }
};
</script>

<style lang="less" scoped>
.columnPerson:hover {
  color: #0078d4 !important;
  cursor: pointer;
}
.windowWrap {
  padding-bottom:30px;
  .title1 {
    font-size: 30px;
    color: #333333;
    text-align: center;
    font-weight: 500;
  }
  .txt1 {
    margin-top: 5px;
    font-size: 18px;
    color: #333333;
    text-align: center;
    font-weight: 400;
  }
  .box {
    width: 100%;
    overflow-x:auto;
    table {
      border-collapse: collapse;
      border: 1px #525152 solid;
      width: auto;
      height: auto;
      margin: 0 auto;
      margin-top: 39px;
    }
    /*模拟对角线*/
    .out {
      // border-top: 70px #f5f5f5 solid;
      /*上边框宽度等于表格第一行行高*/
      width: 176px;
      /*让容器宽度为0*/
      height: 0px;
      /*让容器高度为0*/
      // border-left: 176px #dbdbdb solid;
      /*左边框宽度等于表格第一行第一格宽度*/
      position: relative;
      /*让里面的两个子容器绝对定位*/
    }
    .line {
      position: absolute;
      top: 0;
      left: 0;
      width: 180px;
      height: 1px;
      border: 1px solid #ffffff;
      overflow: hidden;
      transform: rotate(21deg);
    }
    b {
      font-style: normal;
      display: flex;
      position: absolute;
      top: 2px;
      left: 17px;
      width: 60px;
      color: #0078d4;
      img {
        margin-right: 8px;
      }
    }

    em {
      font-style: normal;
      display: flex;
      position: absolute;
      top: -24px;
      left: 98px;
      width: 66px;
      color: #0078d4;
      img {
        margin-right: 8px;
      }
    }
    th,
    td {
      border: 1px #e8e8e8 solid;
      text-align: center;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      width: 130px;
      padding: 0.16rem 0;
    }

    th {
      background: #8fa5b5;
      padding: 0.12rem 0.4rem;
      .title {
        width: 70px;
      }
    }

    .t1 {
      text-align: center;
      background: #65b3ec;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
    }
  }
  .mobile {
    margin-top: 0.5rem;
    padding: 0 0 0 0.25rem;
    .title {
      position: relative;
      display: flex;
      justify-content: space-between;
      padding-bottom: 0.33rem;
      border-bottom: 1px solid #dddddd;
      .top {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .left {
          font-size: 0.38rem;
          color: #262626;
          letter-spacing: 0;
          line-height: 0.38rem;
          font-weight: 500;
        }
        .right {
          width: 0.48rem;
          height: 0.48rem;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .dot {
            width: 0.06rem;
            height: 0.06rem;
            background: #000000;
          }
        }
      }
      .bottom {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 3px;
        width: 1.54rem;
        background: #0078d4;
      }
    }
    .allDepBox {
      padding-top: 0.4rem;
      .itemDepBox {
        margin-bottom: 0.6rem;
        .depName {
          font-size: 0.28rem;
          color: #262626;
          letter-spacing: 0;
          line-height: 0.38rem;
          font-weight: 500;
        }
        .scroll {
          width: 100%;
          overflow-x: scroll;
          .content {
            width: auto;
          }
        }
        .dateWeek {
          flex-shrink: 0;
          margin-top: 0.24rem;
          margin-right: 0.1rem;

          background: #8fa5b5;
          border: 1px solid #8fa5b5;
          width: 1.8rem;
          .date {
            width: 100%;
            font-size: 0.24rem;
            color: #ffffff;
            text-align: center;
            font-weight: 500;
            padding: 0.12rem 0 0.05rem;
          }
          .week {
            width: 100%;
            background: #ffffff;
            font-size: 0.24rem;
            color: #8fa5b5;
            text-align: center;
            font-weight: 500;
            padding: 0.09rem 0 0.05rem;
          }
        }
        .personName {
          margin-top: 0.24rem;
          .rowPerson {
            display: flex;
            font-size: 0.28rem;
            color: #333333;
            text-align: center;
            font-weight: 400;
            border-bottom: 1px solid #ffffff;
            .columnPerson {
              background: #eff7fd;
              flex-shrink: 0;
              width: 1.9rem;
              padding: 0.3rem 0;
            }
          }
        }
      }
    }
  }
  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    left: 0;
    top: 0;
  }
  .deptAlert {
    position: fixed;
    width: 100%;
    z-index: 999;
    left: 0;
    bottom: 0;
    top:10px;
    overflow:auto;
    padding: 0.4rem 0.25rem 0.24rem;
    background: #ffffff;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    .title {
      font-size: 0.3rem;
      color: #262626;
      letter-spacing: 0;
      line-height: 0.38rem;
      font-weight: 500;
    }
    .deptAlertName {
      margin-top: 0.24rem;
      background: rgba(0, 91, 187, 0.05);
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .itemdeptName {
        display: block;
        width: 33.33%;
        padding: 0.26rem 0;
        border-right: 1px solid #fff;
        border-top: 1px solid #fff;
        font-size: 0.24rem;
        color: #005bbb;
        letter-spacing: 0;
        text-align: center;
        line-height: 0.38rem;
        font-weight: 400;
      }
      .itemdeptName:nth-child(3n + 3) {
        border-right: none;
      }
      .itemdeptName:nth-child(3-n) {
        border-top: none;
      }
    }
  }
}

.m-screen-mobile {
}
</style>
